let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cdIZr")).then(() => parcelRequire('2F5b6'));